import { X as attr_class, W as clsx, a5 as attr_style, Q as slot, S as bind_props, a1 as sanitize_props, a2 as stringify } from "./index2.js";
import { f as fallback } from "./render-context.js";
Promise.resolve();
function Animate($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  $$renderer.component(($$renderer2) => {
    let delay = fallback($$props["delay"], "0s");
    let isInView = false;
    $$renderer2.push(`<div${attr_class(clsx($$sanitized_props.class), "svelte-1nqde47", { "animate": isInView, "opacity-0": true })}${attr_style(`--delay: ${stringify(delay)};`)}><!--[-->`);
    slot($$renderer2, $$props, "default", {});
    $$renderer2.push(`<!--]--></div>`);
    bind_props($$props, { delay });
  });
}
export {
  Animate as A
};
